import React from "react";
import Select from "react-select";
import { Button } from "react-bootstrap";
import {
  defaultSubjectsList,
  MENU_PLACEMENT,
} from "../../../admin-screens/constants";
import { customStyle } from "../../../../shared";
import CustomDateFilter from "../../../../shared/components/dateFilter/customDateFilter";

const FilterComponent = (props) => {
  const { dateState, refreshData, setDateState, setSelectedSubject } = props;

  return (
    <div className="container-fluid pt-3">
      <div className="notification-form shadow card px-2">
        <div className="card-body py-4">
          <div className="row col-12 px-0 d-flex justify-content-between">
            <div className="col-6 col-lg-3">
              <Select
                name="subjectsDropdown"
                options={defaultSubjectsList}
                components={{
                  IndicatorSeparator: () => null,
                }}
                getOptionLabel={(option) => option.label}
                getOptionValue={(option) => option.value}
                onChange={(selectedOption) => {
                  setSelectedSubject(selectedOption.value);
                }}
                placeholder="Select Subject"
                isSearchable={true}
                maxMenuHeight={200}
                menuPlacement={MENU_PLACEMENT.AUTO}
                styles={customStyle}
                className="store-brandDropdown"
                aria-label="subjectsDropdown"
              />
            </div>
            <div className="col-6 col-lg-3 d-flex px-0 justify-content-end">
              <Button
                variant="dark"
                className="user-permission-button"
                onClick={() => refreshData(0)}
              >
                Refresh
              </Button>
            </div>
          </div>
          <hr />
          <CustomDateFilter dateState={dateState} setDateState={setDateState} />
        </div>
      </div>
    </div>
  );
};

export default FilterComponent;
